var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { useState, useEffect } from "react";
function useFetch(input, init) {
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [data, setData] = useState(void 0);
  useEffect(() => {
    if (!input) {
      setReady(true);
      return;
    }
    const controller = new AbortController();
    setReady(false);
    setLoading(true);
    setError(void 0);
    fetch(input, __spreadProps(__spreadValues({}, init), {
      signal: controller.signal
    })).then((res) => {
      if (controller.signal.aborted) {
        return Promise.resolve();
      }
      if (!res.ok) {
        throw new Error(`Error during fetch. Status: ${res.status}`);
      }
      return res.json();
    }).then((d) => {
      if (!controller.signal.aborted) {
        setData(d);
      }
    }).catch((err) => {
      if (!controller.signal.aborted) {
        setData(void 0);
        setError(err);
      }
    }).finally(() => {
      if (!controller.signal.aborted) {
        setReady(true);
        setLoading(false);
      }
    });
    return () => {
      controller.abort("Cancelled");
    };
  }, [input, init]);
  return {
    data,
    error,
    loading,
    ready
  };
}
export {
  useFetch as default
};
